(() => {
  // Lieferdatum: Werktage (Mo–Fr) ab heute in echte Daten umrechnen
  const addWorkdays = (from, days) => {
    const d = new Date(from);
    let left = days;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      const wd = d.getDay();
      if (wd !== 0 && wd !== 6) left -= 1;
    }
    return d;
  };
  const eta = (root) => {
    const lang = document.documentElement.lang || 'de-DE';
    const fmt = (d) => d.toLocaleDateString(lang, { weekday: 'short', day: '2-digit', month: '2-digit' });
    root.querySelectorAll('[data-sx-eta]').forEach((el) => {
      const out = el.querySelector('[data-sx-eta-range]');
      const min = parseInt(el.dataset.min, 10);
      const max = parseInt(el.dataset.max, 10);
      if (!out || !min || !max) return;
      const now = new Date();
      const a = fmt(addWorkdays(now, min));
      const b = fmt(addWorkdays(now, max));
      out.textContent = a === b ? a : `${a} – ${b}`;
    });
  };

  const init = (root = document) => {
    eta(root);
    const els = root.querySelectorAll('.sx-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    els.forEach((el) => io.observe(el));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
